import { FormSchema, FormRowSchema, FormFieldSchema } from '../../common/types/FormSchema'
import { FormRow, FormRowItem, ElementForm, ElementType } from '../../modules/Form/models/Form'

function mapFieldType(type: FormFieldSchema['type']): ElementType {
  const map: Record<string, ElementType> = {
    text: 'text',
    number: 'number',
    email: 'email',
    textarea: 'textarea',
    select: 'select',
    multiselect: 'select',
    radio: 'checkboxGroup',
    checkbox: 'checkbox',
    date: 'date',
    file: 'text',
  }
  return map[type] ?? 'text'
}

function mapField(field: FormFieldSchema): ElementForm {
  return {
    type: mapFieldType(field.type),
    name: field.name,
    title: field.label,
    isRequired: field.required,
    options: field.options?.map(o => ({ value: o.value, text: o.label })),
    odooField: '',
  }
}

function mapRow(row: FormRowSchema): FormRow {
  return {
    id: row.id,
    items: row.items.map(item => ({
      field: mapField(item.field),
      width: item.width,
    })),
  }
}

export function formSchemaToDTO(schema: FormSchema): { patientForm: FormRow[]; sampleForm: FormRow[] } {
  const patientSection = schema.sections.find(s => s.id === 'section-patient')
  const sampleSection = schema.sections.find(s => s.id === 'section-sample')

  return {
    patientForm: patientSection ? patientSection.rows.map(mapRow) : [],
    sampleForm: sampleSection ? sampleSection.rows.map(mapRow) : [],
  }
}
